import http from '../../utils/Http/Http'
import { useQuery } from '@tanstack/react-query'

export type SearchCampaignParams = {
	campaign_name?: string
	agent_id?: string
	after_dt?: string
	before_dt?: string
	sort_by?: string
	sort_order?: 'asc' | 'desc'
	page_size?: number
	page_number?: number
}

export const search = async (params: SearchCampaignParams, signal?: AbortSignal) => {
	const response = await http({
		url: '/campaigns/search',
		method: 'POST',
		signal,
		data: {
			campaign_name: params.campaign_name,
			agent_id: params.agent_id,
			after_dt: params.after_dt,
			before_dt: params.before_dt,
			sort_by: params.sort_by,
			sort_order: params.sort_order,
			page_size: params.page_size || 20,
			page_number: params.page_number || 1,
		},
	})

	return response.data
}

export default function useSearchCampaign(queryKey: string, searchParams: SearchCampaignParams = {}) {
	const { data, isFetching } = useQuery({
		queryKey: [queryKey, searchParams],
		queryFn: ({ signal }) => search(searchParams, signal),
	})

	return {
		campaigns: data?.campaigns || [],
		isFetchingResults: isFetching,
		pagination: {
			currentPage: data?.current_page,
			totalPages: data?.total_pages,
			totalRecords: data?.total_records,
		},
	}
}
